// localStorage access throws (SecurityError) when storage is blocked,
// e.g. inside a cross-origin iframe or with third-party storage disabled.

export const safeGetItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (err) {
    return null;
  }
};

export const safeSetItem = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (err) {
    console.warn('localStorage setItem failed', err);
  }
};

export const safeRemoveItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.warn('localStorage removeItem failed', err);
  }
};
